import { render, staticRenderFns } from "./sister-Question.vue?vue&type=template&id=1aad8cd4&scoped=true&"
import script from "./sister-Question.vue?vue&type=script&lang=ts&"
export * from "./sister-Question.vue?vue&type=script&lang=ts&"
import style0 from "./sister-Question.vue?vue&type=style&index=0&id=1aad8cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aad8cd4",
  null
  
)

export default component.exports